<div class="menu-container">

    <div class="menu-header">
        <div class="back-arrow">
            <button class="dotted-arrow" mat-icon-button (click)="closeQuotesList()">←</button>
        </div>
        <h3 class="headline" i18n="@@list-quotes_headline">Wishlist</h3>
    </div>

    <div class="menu-list">
        <ng-container *ngIf="quotes?.length == 0 && !isPending">
            <div i18n="@@list-quotes_no-quotes-available-card-headline" class="no-quotes">No quotes available</div>
        </ng-container>

        <ng-container *ngIf="isPending && quotes?.length == 0">
            <div class="loading">
                <div><mat-spinner [diameter]="70"></mat-spinner></div>
                <div i18n="@@list-quotes_loading-quotes">Loading quotes</div>
            </div>
        </ng-container>

        <ng-container *ngIf="quotes?.length > 0">
            <div *ngFor="let quote of quotes" class="quote">
                <app-quote-card
                (deleteQuote)="onDeleteSubmit($event)"
                (selectQuote)="onSelectQuote($event)"
                [quoteBarItem]="quote">
                </app-quote-card>
            </div>
        </ng-container>
    </div>
</div>
